import Vue from "vue";
import Router from "vue-router";

Vue.use(Router);

export default new Router({
  mode: "history",
  routes: [
    {
      path: "*",
      name: "index",
      meta: {
        divHelper: "g-doc",
        title: "新闻资讯"
      },
      component: () => import("./newsIndex.vue")
    },
    {
      path: "/news/newsDetail",
      name: "newsDetail",
      meta: {
        divHelper: "g-doc",
        title: "新闻详情"
      },
      props: route => ({
        p: Number(route.query.p) || undefined,
        s: Number(route.query.s) || undefined,
        d: Number(route.query.d) || undefined
      }),
      component: () => import("./newsDetail.vue")
    }
  ]
});
